import React from 'react';

function MultiChoiceIcon({ width = "20", height = "20", className, color = "currentColor", tickColor = "currentColor" }) {
    return (
        <svg
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill="none"
        >
            <g id="SVGRepo_iconCarrier">
                <path d="M0 0h48v48H0z" fill="none"></path>
                <g id="Shopicon">
                    {/* Background Box */}
                    <polygon
                        points="31.048,12 31.048,8 8,8 8,40 40,40 40,20.655 36,20.655 36,36 12,36 12,12"
                        fill={color}
                    />
                    {/* Checkmark */}
                    <polygon
                        points="24,24.172 17,17.172 14.171,20 21.172,27 21.171,27 24,29.828 26.828,27 43.828,10 41,7.172"
                        fill={tickColor}
                    />
                </g>
            </g>
        </svg>
    );
}

export default MultiChoiceIcon;
